
<f-dialog
    v-model     = "value"
    :title      = "title"
    :width      = "460"
    :storeLabel = "storeLabel"
    :show-save  = "!!unit"
    @store      = "onSelected"
    @cancel     = "onCancel"
>
    <template v-slot:content>
        <c-site-select-single
            :customer = "customer"
            @search   = "onSearch"
            @site     = "onSite"
        />

        <div v-if="unit" class="unit-selected lm-border pa-2 mr-2" v-html="text">
        </div>
    </template>
</f-dialog>
